import { motion } from 'motion/react'
import { Box } from '@trinity/components'

const iconVariants = {
  top: {
    close: { rotate: 135, y: 3, x: -3 },
    open: { rotate: 0, y: 0 },
  },
  bottom: {
    close: { rotate: 45, y: -7, x: -3 },
    open: { rotate: 0, y: 0 },
  },
}

export interface AnimatedIconProps {
  open: boolean
  side: keyof typeof iconVariants
  top: number
}

export function AnimatedIcon({ open, side, top }: AnimatedIconProps) {
  return (
    <Box
      component={motion.div}
      initial='close'
      animate={open ? 'close' : 'open'}
      variants={iconVariants[side]}
      sx={{
        position: 'absolute',
        right: 29,
        top: top,
        width: 18,
        height: 2,
        bgcolor: 'grey.500',
        zIndex: 'modal',
      }}
    />
  )
}
